import React from 'react';
import { Table, Button } from 'antd';
import Empty from '@icons/eco2/eco2-empty-table.svg';
import Session from '@icons/eco2/eco2-session.svg';
import Event from '@icons/eco2/eco2-event.svg';
import Span from '@icons/eco2/eco2-span.svg';
import { EmptyInfo } from './styled';
import moment from 'moment-timezone';

const defaultTrendsParam = {
  dimensionList: [],
  filterList: [],
  metricList: [],
  timeInterval: `${moment().subtract(6, 'hours').startOf('minute').format()}/${moment().startOf('minute').format()}`,
};

export default function SummaryTable({ loading, columns, data }) {
  const handleBtnClick = (context: string) => {
    const alertItem = {
      session: defaultTrendsParam,
      event: defaultTrendsParam,
      span: defaultTrendsParam,
    };
    const localStorageKey = `eco-server-alert-default`;
    localStorage.setItem(localStorageKey, JSON.stringify(alertItem || ''));

    setTimeout(() => {
      window.open(`${window.conviva.baseUrl}/dashboard/trends/${context}/default`, '_blank');
    }, 200);
  };
  const EmptyContent = () => {
    if (loading) return <div />;
    return (
      <div>
        <Empty style={{ width: '85px', height: '85px' }} />
        <EmptyInfo>
          There are no Experience Alerts for the selected time frame. Try choosing a different time
          range to expand your search.
        </EmptyInfo>
        <EmptyInfo>Or, view Trends to manually explore your application’s performance.</EmptyInfo>
        <div>
          <Button
            style={{ marginRight: '10px' }}
            icon={<Session style={{ marginRight: '8px', verticalAlign: '-2px' }} />}
            onClick={() => {
              handleBtnClick('session');
            }}
          >
            View Experience Trends
          </Button>
          <Button
            style={{ marginRight: '10px' }}
            icon={<Event style={{ marginRight: '8px', verticalAlign: '-2px' }} />}
            onClick={() => {
              handleBtnClick('event');
            }}
          >
            View Client Performance Trends
          </Button>
          <Button
            style={{ marginRight: '10px' }}
            icon={<Span style={{ marginRight: '8px', verticalAlign: '-2px' }} />}
            onClick={() => {
              handleBtnClick('span');
            }}
          >
            View Backend Performance Trends
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Table
      dataSource={data}
      columns={columns}
      pagination={false}
      loading={loading}
      locale={{
        emptyText: <EmptyContent />,
      }}
    />
  );
}
